// import PackageRequestMain from "../../../../features/customer/package-request/components/package-request-main";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import StockInMain from "../../../../features/stock-in/components/stock-in-main";

const title = "Stock In";

const StockInPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <StockInMain />;
  // return "Customer Voucher Page";
};

export default StockInPage;
